function loadMaster(view) {
    return () => import( /* webpackChunkName: "master-[request]" */ `@/components/dashboard/master/${view}.vue`)
}

const routes = [
    {
        path: 'master/study-place',
        name: 'StudyPlace',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak', 'crew']
        },
        component: loadMaster('StudyPlace'),
    },
    {
        path: 'master/study-program',
        name: 'StudyProgram',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak', 'crew']
        },
        component: loadMaster('StudyProgram'),
    },
    {
        path: 'master/province',
        name: 'Province',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak', 'crew']
        },
        component: loadMaster('Province'),
    },
    {
        path: 'master/religion',
        name: 'Religion',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak', 'crew']
        },
        component: loadMaster('Religion'),
    },
    {
        path: 'master/job-level',
        name: 'JobLevel',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak', 'crew']
        },
        component: loadMaster('JobLevel'),
    },
    {
        path: 'master/city',
        name: 'City',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak', 'crew']
        },
        component: loadMaster('City'),
    },
    {
        path: 'master/skill',
        name: 'Skill',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak', 'crew']
        },
        component: loadMaster('Skill'),
    },
    {
        path: 'master/social-media',
        name: 'SocialMedia',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak', 'crew']
        },
        component: loadMaster('SocialMedia'),
    },
    {
        path: 'master/industry-type',
        name: 'IndustryType',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak', 'crew']
        },
        component: loadMaster('IndustryType'),
    },
    {
        path: 'master/department',
        name: 'Department',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak', 'crew']
        },
        component: loadMaster('Department'),
    },
    {
      path: 'master/language',
      name: 'Language',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['superadmin','bkak', 'crew']
      },
      component: loadMaster('Language'),
    },
]

export default routes